import { ServicePluginDefinition } from '@wix/sdk-types';
import {
  Context,
  DecrementAvailabilityRequest,
  DecrementAvailabilityResponse,
  IncrementAvailabilityRequest,
  IncrementAvailabilityResponse,
} from './service-plugins-types.js';
import {
  renameKeysFromSDKRequestToRESTRequest,
  renameKeysFromRESTResponseToSDKResponse,
} from '@wix/sdk-runtime/rename-all-nested-keys';

export interface DecrementAvailabilityEnvelope {
  request: DecrementAvailabilityRequest;
  metadata: Context;
}

export interface IncrementAvailabilityEnvelope {
  request: IncrementAvailabilityRequest;
  metadata: Context;
}

export const provideHandlers = ServicePluginDefinition<{
  /**
   *
   * Reduces the available stock quantity for specified items.
   *
   * Use this method when inventory needs to be decremented due to order events such as order placement or payment. The method supports validation to prevent negative inventory levels when `restrictInventoryValue` is set to true. */
  decrementAvailability(
    payload: DecrementAvailabilityEnvelope
  ): DecrementAvailabilityResponse | Promise<DecrementAvailabilityResponse>;

  /**
   *
   * Increases the available stock quantity for specified items.
   *
   * Use this method when inventory needs to be incremented due to order events such as order cancellation, refund, or order editing.
   * This method does not validate stock levels and allows negative inventory to be corrected. */
  incrementAvailability(
    payload: IncrementAvailabilityEnvelope
  ): IncrementAvailabilityResponse | Promise<IncrementAvailabilityResponse>;
}>('ECOM_INVENTORY', [
  {
    name: 'decrementAvailability',
    primaryHttpMappingPath: '/v1/decrement',
    transformations: {
      toREST: (payload: any) => {
        const toRestResponse = payload;

        return renameKeysFromSDKRequestToRESTRequest(toRestResponse);
      },
      fromREST: (payload: any) => {
        const fromRestRequest = payload;

        return renameKeysFromRESTResponseToSDKResponse(fromRestRequest);
      },
    },
  },

  {
    name: 'incrementAvailability',
    primaryHttpMappingPath: '/v1/increment',
    transformations: {
      toREST: (payload: any) => {
        const toRestResponse = payload;

        return renameKeysFromSDKRequestToRESTRequest(toRestResponse);
      },
      fromREST: (payload: any) => {
        const fromRestRequest = payload;

        return renameKeysFromRESTResponseToSDKResponse(fromRestRequest);
      },
    },
  },
]);
